// extracted by mini-css-extract-plugin
export var grid = "_2d-0";
export var span1 = "_2d-2";
export var span10 = "_2d-b";
export var span10L = "_2d-z";
export var span10M = "_2d-n";
export var span10Xl = "_2d-1b";
export var span11 = "_2d-c";
export var span11L = "_2d-10";
export var span11M = "_2d-o";
export var span11Xl = "_2d-1c";
export var span12 = "_2d-d";
export var span12L = "_2d-11";
export var span12M = "_2d-p";
export var span12Xl = "_2d-1d";
export var span1L = "_2d-q";
export var span1M = "_2d-e";
export var span1Xl = "_2d-12";
export var span2 = "_2d-3";
export var span2L = "_2d-r";
export var span2M = "_2d-f";
export var span2Xl = "_2d-13";
export var span3 = "_2d-4";
export var span3L = "_2d-s";
export var span3M = "_2d-g";
export var span3Xl = "_2d-14";
export var span4 = "_2d-5";
export var span4L = "_2d-t";
export var span4M = "_2d-h";
export var span4Xl = "_2d-15";
export var span5 = "_2d-6";
export var span5L = "_2d-u";
export var span5M = "_2d-i";
export var span5Xl = "_2d-16";
export var span6 = "_2d-7";
export var span6L = "_2d-v";
export var span6M = "_2d-j";
export var span6Xl = "_2d-17";
export var span7 = "_2d-8";
export var span7L = "_2d-w";
export var span7M = "_2d-k";
export var span7Xl = "_2d-18";
export var span8 = "_2d-9";
export var span8L = "_2d-x";
export var span8M = "_2d-l";
export var span8Xl = "_2d-19";
export var span9 = "_2d-a";
export var span9L = "_2d-y";
export var span9M = "_2d-m";
export var span9Xl = "_2d-1a";
export var stretch = "_2d-1";